import { Box, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const WelcomeMessage = () => {
   const { t } = useTranslation();
   const subHeader = t('bonoBot.welcomeMessage.subtitle');

   return (
      <Box
         sx={{
            display: 'flex',
            flex: 1,
            height: 'calc(100vh - 192px)',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            rowGap: '10px',
            mb: 20,
         }}
      >
         <svg width={60} height={60} viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
               d='M30 60c16.569 0 30-13.431 30-30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30'
               fill='#F0CAC9'
            />
            <path
               d='M46.45 27.144c-.704-1.326-1.615-2.32-2.775-3.066l-6.05-3.937h-.042c-1.284-.829-2.734-1.243-4.309-1.284v-3.854a1.08 1.08 0 0 0-.456-.87l-6.05-3.937c-.207-.165-.497-.207-.787-.165l-7.127 1.45c-.497.083-.829.539-.829 1.036v31.657c0 .332.208.663.498.87l6.05 3.937c.165.124.372.166.58.166h.207l6.961-1.41c.373-.082.663-.372.787-.745 3.812 1.16 8.205-.787 10.774-3.605 4.02-4.31 5.096-11.147 2.569-16.243'
               fill='#252626'
            />
            <path
               d='M39.49 23.703c.829 1.533 1.243 3.315 1.243 5.428s-.414 4.144-1.243 5.967a13.7 13.7 0 0 1-3.439 4.64 10.84 10.84 0 0 1-5.097 2.446c-1.947.373-2.403.207-3.48-.083a7.3 7.3 0 0 1-1.41-.622v1.243l-6.96 1.41V12.473l7.127-1.45v11.395a10 10 0 0 1 1.243-.954 9.7 9.7 0 0 1 3.522-1.408c1.906-.373 3.646-.249 5.097.373 1.491.663 2.61 1.74 3.439 3.232zm-6.464 9.24c.332-.704.456-1.491.456-2.32s-.166-1.492-.456-2.113c-.331-.58-.746-.995-1.367-1.244-.58-.248-1.285-.29-2.072-.165s-1.409.456-1.989.953-1.036 1.077-1.326 1.782c-.331.704-.456 1.491-.456 2.32s.166 1.575.498 2.155q.497.87 1.367 1.243c.58.248 1.243.331 1.989.166a4.7 4.7 0 0 0 2.03-.995 5.4 5.4 0 0 0 1.368-1.823'
               fill='#fff'
            />
         </svg>
         <Box>
            <Typography
               textAlign='center'
               sx={{ fontSize: '32px', lineHeight: '38px', fontWeight: 700, color: '#333333', whiteSpace: 'pre-line' }}
            >
               <Trans i18nKey='bonoBot.welcomeMessage.title' />
            </Typography>
         </Box>
         <Box>
            <Typography
               textAlign='center'
               sx={{ fontSize: '24px', lineHeight: '29px', fontWeight: 500, color: '#333333' }}
            >
               {subHeader}
            </Typography>
         </Box>
      </Box>
   );
};

export default WelcomeMessage;
